import * as React from 'react'

import cn from 'classnames'
import { useRecoilValue } from 'recoil'

import insertLineBreakMarkups from '../../../misc/helpers/insertLineBreakMarkups'
import getDescriptionTextBlocks from '../../../misc/helpers/splitStringTextBlocks'
import { cld } from '../../../services/CloudinaryService'
import { locale } from '../../../state/locale/atoms/locale'
import { translate } from '../../../state/locale/selectors/translate'
import { GallerySlider } from '../../reusable/GallerySlider'
import { GoogleMaps } from '../../reusable/GoogleMaps'
import { Link } from '../../reusable/Link'
import { Loading } from '../../reusable/Loading'
import styles from './Estate.module.scss'
import { IEstateProps } from './Estate.types'

export const Estate = ({ data }: IEstateProps) => {
  const lang = useRecoilValue(locale)
  const i18n = useRecoilValue(translate).estate

  const images = data.gallery.map((image) => cld.image(image.provider_metadata.public_id).toURL())

  const criteriaList = data.profileCriteria.map((criteria, index) => (
    <li className={styles.criteria} key={index.toString()}>
      <h3 className={styles.criteriaTitle}>{criteria.title}</h3>
      <ul className={styles.criteriaList}>
        {criteria.criteria?.map((item) => (
          <li className={styles.criteriaItem} key={item.id}>
            <p className={styles.itemText}>{item.content}</p>
          </li>
        ))}
      </ul>
    </li>
  ))

  return (
    <div className={styles.estateWrapper}>
      <h2 className={styles.pageTitle} id={'profile'}>
        {data.profileTitle}
      </h2>
      {getDescriptionTextBlocks(data.profileDescription).map((textBlock, index) => (
        <p className={styles.paragraph} key={index.toString()}>
          {insertLineBreakMarkups(textBlock)}
        </p>
      ))}
      <ol className={styles.criteriaWrapper}>{criteriaList ? criteriaList : <Loading />}</ol>
      <Link className={styles.buttonLink} to={data.boxLink} blank={true}>
        {data.boxLinkTitle}
      </Link>
      <div className={styles.propositionContainer}>
        <p>{i18n.proposition}</p>
        <a href={'mailto:info@westminster.de'}>info@westminster.de</a>
      </div>
      <div className={styles.locationsWrapper}>
        <div className={styles.column}>
          <h2 className={styles.pageTitle} id={'locations'}>
            {data.locationsTitle}
          </h2>
          <p className={styles.paragraph}>{data.locationsDescription}</p>
        </div>
        <div className={cn(styles.column, styles.mapContainer)}>
          <GoogleMaps map={data.locationsMap} locale={lang} />
        </div>
      </div>
      <GallerySlider images={images} />
      <h2 className={cn(styles.paragraph, styles.linkDescription)}>{i18n.linkDescription}</h2>
      <Link className={styles.buttonLink} to={data.estateLink} blank={true}>
        {i18n.linkButton}
      </Link>
    </div>
  )
}
